import { apiRequest } from "./api";

export function listMembershipPlans() {
  return apiRequest("/api/v1/billing/plans");
}

export function listCreditPackages() {
  return apiRequest("/api/v1/credits/packages");
}

export function getCurrentSpaceBilling(spaceId) {
  const id = String(spaceId || "").trim();
  if (!id) {
    return Promise.resolve(null);
  }
  return apiRequest(`/api/v1/spaces/${encodeURIComponent(id)}/billing`);
}

export function previewSubscription(planCode) {
  return apiRequest("/api/v1/billing/subscription-preview", {
    method: "POST",
    body: JSON.stringify({ plan_code: planCode }),
  });
}
